import { createContext, useEffect, useState } from "react";
import hellenicFlag from "../staticImages/hellenicEmblem.jpg";

export const StaticFilesContext = createContext();

const StaticFilesProvider = ({ children }) => {
  const [urlFlag, setUrlFlag] = useState("");

  const makeBlobFromStaticFile = async () => {
    const blob = await fetch(hellenicFlag).then((resp) => resp.blob());
    setUrlFlag(URL.createObjectURL(blob));
  };

  useEffect(() => {
    makeBlobFromStaticFile();
  }, []);

  return (
    <StaticFilesContext.Provider value={{ urlFlag }}>
      {children}
    </StaticFilesContext.Provider>
  );
};

export default StaticFilesProvider;
